<template>
  <div>
    <el-upload
      :file-list="fileList"
      :before-remove="beforeRemove"
      :http-request="customUpload"
      multiple
      :show-file-list="false"
      :disabled="disabled"
    >
      <div slot="tip" class="el-icon-upload" style="margin-left:20px" v-if="showButton">提示：上传文件不大于{{max/(1024*1024)}}MB</div>
      <el-button type="primary" v-if="showButton">
        <i class="el-icon-upload"></i>
        <span>点击上传</span>
      </el-button>
    </el-upload>
    <transition>
      <div class="show-file-list" v-if="showList">
        <div v-for="(item, index) in fileList" :key="index">
          <span>
            {{ item[fileName] }}
          </span>
          <i class="el-icon-close" @click="remove(index)"></i>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { putFile } from "@/api/crmedical/contract/add";

import website from "@/config/website";
export default {
  props: {
    fileList: {
      type: Array
    },
    fileName: {
      type: String,
      default: "originalName",
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    showList: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      max:10*1024*1024
    };
  },

  methods: {
    beforeRemove(file, fileList) {
      if (this.disabled) {
        return false;
      }
      this.fileList = fileList;
      this.update();
    },

    update() {
      // status:'success' 后端会报错
      this.fileList.forEach((item) => {
        item.status = 1;
      });
      this.$emit("update:fileList", this.fileList);
    },
    customUpload(file) {
      if (this.disabled) {
        return false;
      }
      this.max = website.maxUploadSize
      if (file.file.size > this.max) {
        this.$message.error(`文件不能大于${this.max/(1024*1024)}MB`);
      } else {
        let fd = new FormData();
        fd.append("file", file.file);
        putFile(fd).then((res) => {
          res.data.uid = file.file.uid;
          if (res.success) {
            res.data["id"] = res.data["attachId"];
            this.fileList.push(res.data);
            this.update();
          }
        });
      }
    },
    
    remove(index) {
      if (this.disabled) {
        return false;
      }
      this.fileList = this.fileList.splice(index, 1);
    },
  },
};
</script>
<style scoped>
.show-file-list > div {
  display: flex;
  justify-content: space-between;
  padding: 0 50px 0 0;
  align-items: center;
  height: 40px;
  line-height: 40px;
}
.show-file-list > div:hover {
  color: #409eff;
}
</style>